import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalCourseStore from '../../../../../stores/global-course-store';

export const requestAdditionalHoursOperation = async (
  programId: number,
  courseId: number,
  requestedAdditionalHours: number,
  justification: string,
  setLoading: (loading: boolean) => void,
) => {
  setLoading(true);

  try {
    await appApi.requestAdditionalCourseHours(
      programId,
      courseId,
      requestedAdditionalHours,
      justification,
    );
    globalCourseStore.fetchCourseDetails(programId, courseId);
  } catch (error) {
    console.error('Error requesting additional hours:', error);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
